<script setup lang="ts">
import Text from '@uiKit/elements/Text.vue'

interface Props {
  modelValue: boolean
  /** `lg` — the 24px box the invest drawer's confirm uses (Figma 32590:65397). */
  size?: 'md' | 'lg'
}

withDefaults(defineProps<Props>(), { size: 'md' })

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()
</script>

<template>
  <Text
    is="label"
    type="body-sm"
    class="terms-checkbox"
    :class="{ 'terms-checkbox--lg': size === 'lg' }"
  >
    <input
      type="checkbox"
      class="terms-checkbox__input"
      :checked="modelValue"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <Text is="span" class="terms-checkbox__text">
      <slot />
    </Text>
  </Text>
</template>

<style scoped>
.terms-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.15rem;
  cursor: pointer;
}

/* Native checkbox kept — kit doesn't ship a Checkbox element yet.
   TODO: replace with `<Checkbox>` when added. */
.terms-checkbox__input {
  flex-shrink: 0;
  margin-top: 3px;
  width: 15px;
  height: 15px;
  accent-color: var(--p-primary-600);
  cursor: pointer;
}

.terms-checkbox--lg {
  gap: 0.625rem;
}

.terms-checkbox--lg .terms-checkbox__input {
  margin-top: 0;
  width: 24px;
  height: 24px;
}

.terms-checkbox__text {
  line-height: 1.7;
}
</style>
